import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { ExternalLinkIcon, ShoppingCartIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
interface Product {
  url: string;
  name: string;
  description: string;
  imageUrl: string;
}
const loungeProducts: Product[] = [{
  url: 'https://amzn.to/49W8Bym',
  name: 'Medication Tracker',
  description: "Simple but useful when you can't remove pills from a container",
  imageUrl: 'https://m.media-amazon.com/images/I/711hfzLuw+L._AC_SL1500_.jpg'
}, {
  url: 'https://amzn.to/4oBED6D',
  name: 'Pillow',
  description: 'If you know you know',
  imageUrl: 'https://m.media-amazon.com/images/I/81Eea4oOW7L._AC_SL1500_.jpg'
}, {
  url: 'https://amzn.to/4oAI11v',
  name: 'Heating pad',
  description: "Essential item, especially in winter. Don't fall asleep with it on!",
  imageUrl: 'https://m.media-amazon.com/images/I/71ZTDnjcQ9L._AC_SL1500_.jpg'
}, {
  url: 'https://amzn.to/4rQiJ2i',
  name: 'Cozy socks',
  description: 'At least one part of your body can be comfortable',
  imageUrl: 'https://m.media-amazon.com/images/I/817VtdITxeL._AC_SX679_.jpg'
}, {
  url: 'https://amzn.to/4iyHfR4',
  name: 'Cozy socks for foxes',
  description: 'Luxuriate in socks',
  imageUrl: 'https://m.media-amazon.com/images/I/71BnXtes5mL._AC_SX679_.jpg'
}, {
  url: 'https://amzn.to/4aAhYUy',
  name: 'InstantPot',
  description: 'Make your own broth and thank me later',
  imageUrl: 'https://m.media-amazon.com/images/I/71YfFzJ+ySL._AC_SL1500_.jpg'
}, {
  url: 'https://m.media-amazon.com/images/I/810L35Bgx3L._AC_SL1500_.jpg',
  name: "World's best butt cream",
  description: 'Just get this already',
  imageUrl: 'https://m.media-amazon.com/images/I/516FtEVZZJL._AC_SL1500_.jpg'
}, {
  url: 'https://amzn.to/4aA79BU',
  name: 'Trashy Fiction',
  description: 'Trashy fiction goes a long way to feeling good.',
  imageUrl: 'https://m.media-amazon.com/images/I/81o4TqE64ZL._SL1500_.jpg'
}, {
  url: 'https://amzn.to/4oAh6D4',
  name: 'A must-read if you have or are a kid with IBD',
  description: 'Essential reading for families navigating IBD',
  imageUrl: 'https://m.media-amazon.com/images/I/811Ohs0RGlL._SL1500_.jpg'
}];
const survivalKitProducts: Product[] = [{
  url: 'https://amzn.to/4iJZrHK',
  name: 'Single packet wipes',
  description: 'Throw one in all of your pockets. Thank me later.',
  imageUrl: 'https://m.media-amazon.com/images/I/712DcuoqjTL._SL1500_.jpg'
}, {
  url: 'https://amzn.to/4pgUZT7',
  name: 'Electrolytes',
  description: 'You need your energy, passing out is not cool.',
  imageUrl: 'https://m.media-amazon.com/images/I/7131LcjiPRL._SL1500_.jpg'
}, {
  url: 'https://amzn.to/3Kvp2qY',
  name: 'Cashew butter single serve packets',
  description: "Bring along some calories just in case you can't find anything around you can eat",
  imageUrl: 'https://m.media-amazon.com/images/I/61yPXO9TDwL.SL1234.jpg'
}, {
  url: 'https://amzn.to/4owVKGm',
  name: 'Germs are scary',
  description: 'Hand sanitizer is cute too.',
  imageUrl: 'https://m.media-amazon.com/images/I/61tJ2MheMDL.SL1500.jpg'
}, {
  url: 'https://amzn.to/3MdTRkF',
  name: 'Poo-Pourri',
  description: 'Embarrassment reducer https://www.youtube.com/watch?v=oaQ1CdISw8o',
  imageUrl: 'https://m.media-amazon.com/images/I/81WByczoP2L._AC_SL1500_.jpg'
}, {
  url: 'https://amzn.to/44OmfA7',
  name: 'Imodium',
  description: 'Yes, you can take this if it helps you leave the house',
  imageUrl: 'https://m.media-amazon.com/images/I/71xIGD26ZpL._AC_SL1500_.jpg'
}, {
  url: 'https://amzn.to/48nuX9q',
  name: 'MiraLax single serve',
  description: "Don't hesitate to stick one in your purse",
  imageUrl: 'https://m.media-amazon.com/images/I/810L35Bgx3L._AC_SL1500_.jpg'
}, {
  url: 'https://www.etsy.com/listing/1585841640/wet-dry-bag-for-reusable-cloth-diapers',
  name: 'Survival bag',
  description: 'Get yourself a cute bag on Etsy to carry everything around',
  imageUrl: 'https://i.etsystatic.com/35340981/r/il/8e8894/4232132528/il_1140xN.4232132528_lar3.jpg'
}];
const ProductCard: React.FC<{
  product: Product;
  index: number;
}> = ({
  product,
  index
}) => {
  // Function to render description with clickable links
  const renderDescription = (description: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = description.split(urlRegex);
    return parts.map((part, i) => {
      if (part.match(urlRegex)) {
        return <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" onClick={e => e.stopPropagation()} data-id="element-318">
            {part}
          </a>;
      }
      return <span key={i} data-id="element-319">{part}</span>;
    });
  };
  return <motion.a href={product.url} target="_blank" rel="noopener noreferrer" className="bg-background-light border-2 border-gray-800 rounded-lg overflow-hidden hover:border-primary transition-all group" initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.1 * index,
    duration: 0.3
  }} whileHover={{
    scale: 1.02,
    y: -4
  }} whileTap={{
    scale: 0.98
  }} data-id="element-320">
      <div className="aspect-video w-full overflow-hidden bg-gray-900" data-id="element-321">
        <img src={product.imageUrl} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-322" />
      </div>
      <div className="p-4" data-id="element-323">
        <div className="flex items-start justify-between gap-2 mb-2" data-id="element-324">
          <h3 className="text-base font-semibold text-text-primary group-hover:text-primary transition-colors" data-id="element-325">
            {product.name}
          </h3>
          <ExternalLinkIcon className="h-4 w-4 text-text-secondary group-hover:text-primary transition-colors flex-shrink-0 mt-0.5" data-id="element-326" />
        </div>
        <p className="text-xs text-text-secondary mb-2 line-clamp-2" data-id="element-327">
          {renderDescription(product.description)}
        </p>
        <div className="text-xs text-primary font-semibold" data-id="element-328">
          View on Amazon →
        </div>
      </div>
    </motion.a>;
};
export const ResourcesPage: React.FC = () => {
  return <div className="min-h-screen flex flex-col bg-background" data-id="element-329">
      <Helmet data-id="element-330">
        <title data-id="element-331">Shopping - IBD Rant</title>
        <meta name="description" content="Helpful product recommendations for living with IBD." data-id="element-332" />
        <meta property="og:type" content="website" data-id="element-333" />
        <meta property="og:title" content="Shopping - IBD Rant" data-id="element-334" />
        <meta property="og:description" content="Helpful product recommendations for living with IBD." data-id="element-335" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-336" />
        <meta name="twitter:title" content="Shopping - IBD Rant" data-id="element-337" />
        <meta name="twitter:description" content="Helpful product recommendations for living with IBD." data-id="element-338" />
      </Helmet>
      <Header data-id="element-339" />
      <main className="flex-grow py-12 px-4 bg-background" data-id="element-340">
        <div className="max-w-6xl mx-auto" data-id="element-341">
          <motion.div className="text-center mb-16" initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-342">
            <motion.h1 className="text-3xl md:text-4xl font-bold mb-4" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-343">
              Reccomendations from your IBD BFF
            </motion.h1>
          </motion.div>

          {/* Shopping Section */}
          <motion.section id="shopping-section" className="mb-16" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} data-id="element-344">
            <div className="flex items-center gap-3 mb-6" data-id="element-345">
              <ShoppingCartIcon className="h-6 w-6 text-primary" data-id="element-346" />
              <h2 className="text-2xl font-bold" data-id="element-347">Shopping</h2>
            </div>

            {/* Lounge Products Subsection */}
            <div className="mb-16" data-id="element-348">
              <div className="text-center mb-10" data-id="element-349">
                <h3 className="text-2xl font-bold" data-id="element-350">
                  For cozier and more comfortable lounging at home
                </h3>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-351">
                {loungeProducts.map((product, index) => <ProductCard key={product.url} product={product} index={index} data-id="element-352" />)}
              </div>
            </div>

            {/* Survival Kit Products Subsection */}
            <div className="mb-10" data-id="element-353">
              <div className="text-center mb-10" data-id="element-354">
                <h3 className="text-2xl font-bold mb-4" data-id="element-355">
                  Real-world survival kit
                </h3>
                <p className="text-text-secondary" data-id="element-356">
                  A survival kit when out in the wild is essential. Pack
                  whatever you need to be confident and prepared for all
                  situations. Don't forget snacks, electrolytes, a trash bag and
                  some extra undies!
                </p>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-357">
                {survivalKitProducts.map((product, index) => <ProductCard key={product.url} product={product} index={index} data-id="element-358" />)}
              </div>
            </div>

            {/* Legal disclaimer at bottom */}
            <p className="text-sm text-text-secondary text-center mt-10" data-id="element-359">
              Legal vomit: As an Amazon Associate I earn from qualifying
              purchases.
            </p>
          </motion.section>
        </div>
      </main>
      <Footer data-id="element-360" />
    </div>;
};